import React from "react"
import styled from "styled-components"
import { breakpoints } from "../../../theme"

const StyledTextArea = styled.textarea`
  font-family: var(--family);
  padding: 10px 0px;
  opacity: 0.75;
  border-radius: 0;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0.055em;
  border: none;
  border-radius: 3px;
  height: 120px;
  width: 100%;
  max-width: 100%;
  @media (min-width: ${breakpoints.medium}px) {
    font-size: 16px;
  }

  &:focus {
    color: rgba(4, 6, 44, 1);
    opacity: 1;
    outline: none;
  }
`

const Border = styled.div`
  border-bottom: 1px solid #000;
`

const TextArea = ({ field, ...props }) => {
  delete props.form

  return (
    <Border>
      <StyledTextArea {...field} {...props} />
    </Border>
  )
}

export { TextArea }
